'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _ZoomOutOutlined = _interopRequireDefault(require('./lib/icons/ZoomOutOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _ZoomOutOutlined;
exports.default = _default;
module.exports = _default;